import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=53a59720&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=53a59720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a59720",
  null
  
)

export default component.exports